import {React, extend, _n, _s} from 'pexui';
import * as utils from '../../utilities/utils';
var Promise = utils.Promise;

// A display of HTML content
export function Html({ref, tag, id, className, style, content, value, hideEmpty, onLoad, onError}){
    tag = tag || 'div';
    content = content || '';
    //style = extend({
    //    'overflow-y': 'auto'
    //}, style);
    
    let isPromise = false;
    let isPlain = false;
    if(utils.isContentId(content) || /^\s*url\((.*)\)\s*$/.test(content)){
        content = utils.getHtmlContent(content, value);
        isPromise = content instanceof Promise;
        if(!isPromise){
            isPlain = !utils.isHtml(content);
        }
    }else{
        content = utils.evalExpr(content, value);
        isPlain = !utils.isHtml(content);        
    }
    
    // hideEmpty: hide the component if the content is empty
    if((!isPromise) && hideEmpty && (!content)){
        style = style || {};
        style.display = "none";
    }

    const elem = React.createElement(tag, {id: id, className: className, style:style, ref:ref},
           isPlain? content: '');

    if(isPromise){
        content.then( resp => {
            elem.innerHTML = resp.data;
            if(hideEmpty && !resp.data){
                elem.style.display = 'none';
            }

            if(typeof onLoad === 'function'){
                onLoad(elem);
            }
        }, onError);
    }else{
        if(!isPlain){
            elem.innerHTML = content;
        }

        // immediately inovke the callback
        if(typeof onLoad === 'function'){
            setTimeout(function(){
                onLoad(elem);
            }, 100);
        }
    }

    return elem;
}



// WEBPACK FOOTER //
// ./application/src/views/comps/html.jsx